import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { BotmakerCallNotificationPayload } from "../interfaces/botmaker.interface";

@Injectable()
export class BotmakerService {
  constructor(private http: HttpClientService) {}

  public sendCallNotification(parameters: BotmakerCallNotificationPayload): Observable<unknown> {
    return this.http
      .post("/api/botmaker_whatsapp/send_call_notification", parameters)
      .pipe(tap((_) => console.log("BotmakerService.sendCallNotification: Ok.")));
  }
}
